import { CssBaseline,  } from "@mui/material"
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles"
import { default as Contact } from "./Contact/Form"
import { default as Documentation } from "./Documentation/Form"
import { default as JourneesDecouverte } from "./JourneesDecouverte/Form"
import { default as Newsletter } from "./Newsletter/Form"
import { default as JourneesPortesOuvertes } from "./JourneesPortesOuvertes/Form"
import { default as RdvOrientation } from "./RdvOrientation/Form"
import { default as DocumentationBachelors } from "./LPBachelor/Form"
import theme from "./Theme/index"
import { FormContextProvider } from "hooks/useForm"
import Forms from "../Forms"

const DocumentationESME = () => {
  return (
    <FormContextProvider>
      <ThemeProvider theme={theme}>
        <Forms>
          <CssBaseline />
          <Documentation />
        </Forms>
      </ThemeProvider>
    </FormContextProvider>
  )
}

const DocumentationBachelorsESME = () => {
  return (
    <FormContextProvider>
      <ThemeProvider theme={theme}>
        <Forms>
          <CssBaseline />
          <DocumentationBachelors />
        </Forms>
      </ThemeProvider>
    </FormContextProvider>
  )
}

const JourneesDecouverteESME = () => {
  return (
    <FormContextProvider>
      <ThemeProvider theme={theme}>
        <Forms>
          <CssBaseline />
          <JourneesDecouverte />
        </Forms>
      </ThemeProvider>
    </FormContextProvider>
  )
}

const JourneesPortesOuvertesESME = () => {
  return (
    <FormContextProvider>
      <ThemeProvider theme={theme}>
        <Forms>
          <CssBaseline />
          <JourneesPortesOuvertes />
        </Forms>
      </ThemeProvider>
    </FormContextProvider>
  )
}

const RdvOrientationESME = () => {
  return (
    <FormContextProvider>
      <ThemeProvider theme={theme}>
        <Forms>
          <CssBaseline />
          <RdvOrientation />
        </Forms>
      </ThemeProvider>
    </FormContextProvider>
  )
}

const NewsletterESME = () => {
  return (
    <FormContextProvider>
      <ThemeProvider theme={theme}>
        <Forms>
          <CssBaseline />
          <Newsletter />
        </Forms>
      </ThemeProvider>
    </FormContextProvider>
  )
}

const ContactESME = () => {
  return (
    <FormContextProvider>
      <ThemeProvider theme={theme}>
        <Forms>
          <CssBaseline />
          <Contact />
        </Forms>
      </ThemeProvider>
    </FormContextProvider>
  )
}

export { DocumentationESME, DocumentationBachelorsESME, JourneesDecouverteESME, JourneesPortesOuvertesESME, RdvOrientationESME, NewsletterESME, ContactESME }
